__turbopack_context__.v({
  "bold": "YC_E0q_bold",
  "container": "YC_E0q_container",
  "rightContent": "YC_E0q_rightContent",
  "separator": "YC_E0q_separator",
  "totalItemsCount": "YC_E0q_totalItemsCount",
});
